var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgExcelFileIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 35,
    height: 41,
    viewBox: "0 0 35 41",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "ExcelFile_Icon"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\xC3\xA9 7",
    d: "M33.9662 39.6262H4.86621V0.826172H25.5542V9.53217H33.9662V39.6262Z",
    fill: "#FCFCFC",
    stroke: "#818181",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\xC3\xA9 8",
    d: "M33.9242 9.67305L25.5122 0.973047L25.9822 0.373047L34.4392 9.04705L33.9242 9.67305Z",
    fill: "#818181"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle 7",
    d: "M17.76 10.5703H2C0.89543 10.5703 0 11.4657 0 12.5703V28.3303C0 29.4349 0.89543 30.3303 2 30.3303H17.76C18.8646 30.3303 19.76 29.4349 19.76 28.3303V12.5703C19.76 11.4657 18.8646 10.5703 17.76 10.5703Z",
    fill: "#107C42"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Groupe 3"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\xC3\xA9 9",
    d: "M15.093 26.9543H12.46L4.66602 13.9463H7.35201L15.093 26.9543Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\xC3\xA9 10",
    d: "M4.66602 26.9543H7.29902L15.093 13.9463H12.407L4.66602 26.9543Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle 8",
    d: "M25.553 15.6221H20.793V17.7331H25.553V15.6221Z",
    fill: "#21A365"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle 9",
    d: "M31.4358 15.6221H26.6758V17.7331H31.4358V15.6221Z",
    fill: "#33C481"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle 10",
    d: "M25.553 18.8115H20.793V20.9225H25.553V18.8115Z",
    fill: "#107C42"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle 11",
    d: "M31.4358 18.8115H26.6758V20.9225H31.4358V18.8115Z",
    fill: "#21A365"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle 12",
    d: "M25.553 21.999H20.793V24.11H25.553V21.999Z",
    fill: "#195D38"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle 13",
    d: "M31.4358 21.999H26.6758V24.11H31.4358V21.999Z",
    fill: "#104B2B"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExcelFileIcon);
export default __webpack_public_path__ + "static/media/ExcelFileIcon.ae3e43dfcd8b84bc6bb821ec50ea2509.svg";
export { ForwardRef as ReactComponent };